import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';

const FooterContent = () => {
    return (
        <Container maxWidth="xl">
            {/* <Grid container spacing={0} alignItems="center" justifyItems="center">
                <Grid item xs={12} md={12}>
                    <Box sx={{ py: 2, textAlign: 'center' }}>
                        <Typography fontSize="small" sx={{ color: 'white' }}>
                            {`Copyright Multi-Apartment Management @${new Date().getFullYear()} `}
                            All rights reserved
                        </Typography>
                        <Typography fontSize="small" sx={{ color: 'rgba(255,255,255,0.9)', mt: 0.5 }}>
                            Designed to make your building smarter and your life easier.
                        </Typography>
                    </Box>
                </Grid>
            </Grid> */}
            <Box sx={{ height: '60px' }} />
        </Container>
    );
};

export default FooterContent;
